import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { CommonModule } from '@angular/common';
import { SystemToastComponent } from './templates/system-toast/system-toast';
import { DomainVersioningToastComponent } from './templates/domain-versioning-toast/domain-versioning-toast';

@Component({
  selector: 'app-base-toast',
  standalone: true,
  imports: [ToastModule, FileUploadModule, ProgressBarModule, CommonModule, SystemToastComponent, DomainVersioningToastComponent],
  templateUrl: './base-toast.html',
  styleUrl: './base-toast.scss'
})
export class BaseToastComponent {}
